export default "__VITE_ASSET__DgFc9P4U__";